import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FlattenedSequence } from '@pixacare/dtos';
import { SequenceHttpService } from '@services/http/sequence.http.service';
import { RequestResult } from '@shared/request-state/models/request-result';
import { withRequestResult } from '@shared/request-state/rx-pipes/with-request-result.pipe';
import { lifeCycleActions } from '@shared/store/life-cycle/life-cycle.actions';
import { sequencesActions } from '@shared/store/sequences/sequences.actions';
import { catchError, map, Observable, throwError } from 'rxjs';
import { SequenceMediaUploadService } from './sequence-media-upload.service';

@Injectable()
export class SequenceCreationService {
  private readonly sequenceService = inject(SequenceHttpService);
  private readonly store = inject(Store);
  private readonly mediaUploadService = inject(SequenceMediaUploadService);

  createSequence(clientCode: string, data: FormData, medias: File[]): Observable<RequestResult<FlattenedSequence>> {
    return this.sequenceService.createSequence(data).pipe(
      map((sequence: FlattenedSequence) => {
        // The medias are not uploaded yet: the created sequence starts with an empty medias list
        const createdSequence: FlattenedSequence = { ...sequence, medias: sequence.medias ?? [] };

        this.store.dispatch(sequencesActions.createSequenceSuccess({ clientCode, sequence: createdSequence }));

        // Medias upload continues in the background (NgRx effects) so the dialog can close right
        // away — same path as the edit dialog.
        this.mediaUploadService.attachMedias(clientCode, createdSequence, medias);

        return createdSequence;
      }),
      catchError((error: Error) => {
        this.store.dispatch(lifeCycleActions.loadError({ error }));
        return throwError(() => error);
      }),
      withRequestResult(),
    );
  }
}
